import { z } from 'zod'
import { ContentfulRichTextDocumentSchema } from './common'
import { ContentfulAssetSchema } from './asset'

const ContenfulCtaSchema = z.object({
  label: z.string(),
  link: z.string(),
  variant: z.string(),
})

const ContentfulBadgeSchema = z.object({
  label: z.string(),
})

export const ContentfulHeroSectionSchema = z.object({
  entryId: z.string().optional(),
  heading: z.string().optional(),
  image: ContentfulAssetSchema.optional(),
  body: ContentfulRichTextDocumentSchema.optional(),
})

export const ContentfulComponentHeroSchemaMain = ContentfulHeroSectionSchema.extend({
  internalName: z.string().optional(),
  identifier: z.string().optional(),
  subheading: z.string().optional(),
  bodyCopy: ContentfulRichTextDocumentSchema.optional(),
  cta: ContenfulCtaSchema.optional(),
  badge: ContentfulBadgeSchema.optional(),
})

export const ContentfulComponentHeroSchemaVariant = ContentfulComponentHeroSchemaMain.extend({
  variant: ContentfulComponentHeroSchemaMain.optional(),
})

export const ContentfulHeroSchema = z.union([
  ContentfulComponentHeroSchemaVariant,
  ContentfulComponentHeroSchemaMain,
])

export type ContentfulComponentHero = z.infer<typeof ContentfulComponentHeroSchemaVariant>
export type ContentfulHeroSection = z.infer<typeof ContentfulHeroSectionSchema>
export type ContentfulHero = z.infer<typeof ContentfulHeroSchema>
